import { render, staticRenderFns } from "./ConvalidateShift.vue?vue&type=template&id=60a3b794"
import script from "./ConvalidateShift.vue?vue&type=script&lang=js"
export * from "./ConvalidateShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports